module.exports = __webpack_public_path__ + "static/media/google_cloud.cbd43414.png";